/**
 * Normalize mega menu heights so they share the tallest min-height.
 */
export const megaMenuHeights = {
    resizeTimeout: null,
    boundResizeHandler: null,

    init() {
        this.boundResizeHandler = this.handleResize.bind(this);
        // Run once on init and again after full load to catch late layout changes (e.g., fonts/images)
        this.applyHeights();
        window.addEventListener('load', () => this.applyHeights());
        window.addEventListener('resize', this.boundResizeHandler);
    },

    getMenus() {
        return document.querySelectorAll('[data-mega-menu]');
    },

    clearHeights(menus) {
        menus.forEach(menu => {
            menu.style.minHeight = '';
            menu.style.height = '';
        });
    },

    applyHeights() {
        const menus = this.getMenus();
        if (!menus.length) return;

        // Only enforce equal heights on desktop
        if (window.innerWidth < 1024) {
            this.clearHeights(menus);
            return;
        }

        // Reset first so measurements reflect natural heights
        this.clearHeights(menus);

        let maxHeight = 0;

        menus.forEach(menu => {
            // scrollHeight is more reliable for measuring full content height
            const height = menu.scrollHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });

        if (!maxHeight) return;

        menus.forEach(menu => {
            // Set both height and min-height so children using h-full can stretch
            menu.style.height = `${maxHeight}px`;
            menu.style.minHeight = `${maxHeight}px`;
        });
    },

    handleResize() {
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }

        this.resizeTimeout = setTimeout(() => {
            this.applyHeights();
        }, 150);
    }
};

